import { ApolloClient, InMemoryCache } from '@apollo/client/core/index.js';
import { Subject } from 'rxjs';
import { Constants } from './api.constants.js';
import { typeDefs } from '../schema/schema.js';
/**
 * Represents the interface for the Dada API service.
 */
export class DadaApiService {
    request = {};
    fragments = '';
    endpoint = '';
    apikey = '';
    apiSubject = new Subject();
    timeOutSet = false;
    timeOutSetting = 300;
    apolloClient;
    constructor(endpoint, apikey) {
        this.setEndpointAndApikey(endpoint, apikey);
    }
    setEndpointAndApikey(endpoint, apikey) {
        this.endpoint = endpoint || Constants.DADA_ENDPOINT;
        this.apikey = apikey || Constants.DADA_APIKEY;
        this.createClient();
    }
    createClient() {
        if (this.apolloClient) {
            this.apolloClient.stop();
        }
        this.apolloClient = new ApolloClient({
            uri: this.endpoint,
            headers: {
                apikey: this.apikey,
            },
            cache: new InMemoryCache(),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            },
            typeDefs,
        });
    }
    getQuery() {
        // Override
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateRequest(_newRequest, _fragments) {
        // Override
    }
    fetch() {
        return this.apiSubject.asObservable();
    }
}
//# sourceMappingURL=dada-api.service.js.map